import {
  package_overall,
  package_cluster,
  package_area,
  package_branch,
  package_daily_overall,
  package_daily_cluster,
  package_daily_area,
  package_daily_branch,
} from "../../services/reports/packages_service";
import { actionTypes } from "../action_types";

const defaultPackageData = { packageSummaries: [] };

const createPackageAction = (fetchFunction, actionType) => (data) => (dispatch) => {
  return fetchFunction(data).then((resp) => {
    if (resp.problem === null) {
      dispatch({
        type: actionType,
        payload: resp.data !== null ? resp.data : defaultPackageData,
      });
    }
    return Promise.resolve(resp);
  });
};

export const GetPackageOverall = createPackageAction(
  package_overall,
  actionTypes.REPORTS_PACKAGE_GET_OVERALL
);

export const GetPackageCluster = createPackageAction(
  package_cluster,
  actionTypes.REPORTS_PACKAGE_GET_CLUSTER
);

export const GetPackageArea = createPackageAction(
  package_area,
  actionTypes.REPORTS_PACKAGE_GET_AREA
);

export const GetPackageBranch = createPackageAction(
  package_branch,
  actionTypes.REPORTS_PACKAGE_GET_BRANCH
);

export const GetPackageDailyOverall = createPackageAction(
  package_daily_overall,
  actionTypes.REPORTS_DAILY_PACKAGE_GET_OVERALL
);

export const GetPackageDailyCluster = createPackageAction(
  package_daily_cluster,
  actionTypes.REPORTS_DAILY_PACKAGE_GET_CLUSTER
);

export const GetPackageDailyArea = createPackageAction(
  package_daily_area,
  actionTypes.REPORTS_DAILY_PACKAGE_GET_AREA
);

export const GetPackageDailyBranch = createPackageAction(
  package_daily_branch,
  actionTypes.REPORTS_DAILY_PACKAGE_GET_BRANCH
);
